/**
 * Download button feedback: idle -> preparing -> handoff -> idle.
 * Pure transitions for `node --test`; the hook owns the timer.
 * Each start() opens a new generation; events carrying an older one are ignored.
 */
export const HANDOFF_MS = 2500;

export const idleFeedback = (gen = 0) => ({ phase: 'idle', gen, until: 0 });

// Accepted only while idle; otherwise the same state object comes back.
export function startFeedback(state) {
  if (state.phase !== 'idle') return state;
  return { phase: 'preparing', gen: state.gen + 1, until: 0 };
}

// The browser was handed the file.
export function handoffFeedback(state, gen, now) {
  if (state.phase !== 'preparing' || state.gen !== gen) return state;
  return { phase: 'handoff', gen, until: now + HANDOFF_MS };
}

// The request failed or nothing was handed over.
export function failFeedback(state, gen) {
  if (state.phase !== 'preparing' || state.gen !== gen) return state;
  return idleFeedback(state.gen);
}

// Selection or session changed: drop whatever is in flight.
export function resetFeedback(state) {
  if (state.phase === 'idle') return state;
  return idleFeedback(state.gen + 1);
}

export function expireFeedback(state, now) {
  if (state.phase !== 'handoff' || now < state.until) return state;
  return idleFeedback(state.gen);
}
